module.exports = __webpack_public_path__ + "static/12-008532dc4aff96efa9926db4c7cf57a3.jpg";